import { DOCUMENT } from '@angular/common';
import {
  Directive,
  OnInit,
  OnDestroy,
  ElementRef,
  Inject,
  NgZone,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

@Directive({
  selector: '[ngxFreeDragging]',
})
export class FreeDraggingDirective implements OnInit, OnDestroy {
  private element!: HTMLElement;
  private destroy$ = new Subject<void>();

  private currentX = 0;
  private currentY = 0;

  constructor(
    private elementRef: ElementRef,
    private zone: NgZone,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.element = this.elementRef.nativeElement as HTMLElement;
    this.initDrag();
  }

  private initDrag(): void {
    this.zone.runOutsideAngular(() => {
      const mouseDown$ = fromEvent<MouseEvent>(this.element, 'mousedown');
      const mouseMove$ = fromEvent<MouseEvent>(this.document, 'mousemove');
      const mouseUp$ = fromEvent<MouseEvent>(this.document, 'mouseup');

      mouseDown$
        .pipe(
          tap(() => this.element.classList.add('free-dragging')),
          switchMap((startEvent) => {
            const initialX = startEvent.clientX - this.currentX;
            const initialY = startEvent.clientY - this.currentY;

            return mouseMove$.pipe(
              tap((moveEvent) => {
                moveEvent.preventDefault();

                this.currentX = moveEvent.clientX - initialX;
                this.currentY = moveEvent.clientY - initialY;

                // Direct DOM update → NO Angular CD
                this.element.style.transform = `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;
              }),
              takeUntil(mouseUp$)
            );
          }),
          takeUntil(this.destroy$)
        )
        .subscribe();

      mouseUp$
        .pipe(
          tap(() => this.element.classList.remove('free-dragging')),
          takeUntil(this.destroy$)
        )
        .subscribe();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// import { DOCUMENT } from '@angular/common';
// import {
//   Directive,
//   OnInit,
//   OnDestroy,
//   ElementRef,
//   Inject,
// } from '@angular/core';
// import { fromEvent, Subscription } from 'rxjs';
// import { takeUntil } from 'rxjs/operators';

// @Directive({
//   selector: '[ngxFreeDragging]',
// })
// export class FreeDraggingDirective implements OnInit, OnDestroy {
//   private element: HTMLElement;

//   private subscriptions: Subscription[] = [];

//   constructor(
//     private elementRef: ElementRef,
//     @Inject(DOCUMENT) private document: any
//   ) {}

//   ngOnInit(): void {
//     this.element = this.elementRef.nativeElement as HTMLElement;
//     this.initDrag();
//   }

//   initDrag(): void {
//     // 1
//     const dragStart$ = fromEvent<MouseEvent>(this.element, 'mousedown');
//     const dragEnd$ = fromEvent<MouseEvent>(this.document, 'mouseup');
//     const drag$ = fromEvent<MouseEvent>(this.document, 'mousemove').pipe(
//       takeUntil(dragEnd$)
//     );

//     // 2
//     let initialX: number,
//       initialY: number,
//       currentX = 0,
//       currentY = 0;

//     let dragSub: Subscription;

//     // 3
//     const dragStartSub = dragStart$.subscribe((event: MouseEvent) => {
//       initialX = event.clientX - currentX;
//       initialY = event.clientY - currentY;
//       this.element.classList.add('free-dragging');

//       // 4
//       dragSub = drag$.subscribe((event: MouseEvent) => {
//         event.preventDefault();

//         currentX = event.clientX - initialX;
//         currentY = event.clientY - initialY;

//         this.element.style.transform =
//           'translate3d(' + currentX + 'px, ' + currentY + 'px, 0)';
//       });
//     });

//     // 5
//     const dragEndSub = dragEnd$.subscribe(() => {
//       initialX = currentX;
//       initialY = currentY;
//       this.element.classList.remove('free-dragging');
//       if (dragSub) {
//         dragSub.unsubscribe();
//       }
//     });

//     // 6
//     this.subscriptions.push.apply(this.subscriptions, [
//       dragStartSub,
//       dragSub,
//       dragEndSub,
//     ]);
//   }

//   ngOnDestroy(): void {
//     this.subscriptions.forEach((s) => s && s.unsubscribe());
//   }
// }
